import { PifApprovalBand } from "../types";

/** Clamped 0–100 position of `value` between `min` and `max`, for the pay-band marker bar. */
export const bandPercent = (value: number, min: number, max: number): number => {
  if (max === min) return 0;
  return Math.max(0, Math.min(100, ((value - min) / (max - min)) * 100));
};

export const bandFillStyle = (band: PifApprovalBand): { left: string; width: string } => {
  const left = bandPercent(band.hiringMin, band.positionMin, band.positionMax);
  const right = bandPercent(band.hiringMax, band.positionMin, band.positionMax);
  return { left: `${left}%`, width: `${right - left}%` };
};

/** "Link expires in Nh" from an ISO timestamp, computed client-side so it stays accurate
 * across time zones and however long the page has been open (not a pre-baked string). */
export const formatExpiresIn = (expiresAtIso: string): string => {
  const hoursLeft = Math.round((new Date(expiresAtIso).getTime() - Date.now()) / (60 * 60 * 1000));
  if (hoursLeft <= 0) return "Link expired";
  if (hoursLeft === 1) return "Link expires in 1 hour";
  return `Link expires in ${hoursLeft} hours`;
};
